import { getToken } from "@/utils/auth";
import Vue from "vue";

const commonVaribleMixin = {
  data() {
    return {
      scrollContainerHeight: 0,
      currentStep: 1
    };
  },
  created() {
    Vue.prototype.$token = getToken();
  },
  mounted() {},
  methods: {
    isShowBtn(code) {
      let allPermissionList = [];
      let buttonAuth = JSON.parse(sessionStorage.getItem("USER_AUTH") || "[]");
      buttonAuth.forEach(v => {
        allPermissionList.push(v.action);
      });
      return !allPermissionList.includes(code);

      // let gFlag = false; //禁用命中
      // let invalidFlag = false; //无效命中
      // if (
      //   allPermissionList != null &&
      //   allPermissionList != "" &&
      //   allPermissionList != undefined &&
      //   allPermissionList.length > 0
      // ) {
      //   for (var itemG of allPermissionList) {
      //     if (code === itemG.action) {
      //       if (itemG.status === "1") {
      //         invalidFlag = true;
      //         break;
      //       }
      //     }
      //   }
      // }
      // if (invalidFlag) {
      //   return false;
      // } else {
      //   return true;
      // }
    },
    backPrev() {
      this.$router.back();
    }
  }
};

export default commonVaribleMixin;
